import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, ChevronRight, ArrowRight } from 'lucide-react';
import SectionHeading from '../common/SectionHeading';
import ReelCard from '../reels/ReelCard';

const MAX_REELS = 30;

function ReelsSection({ reels, title = "थप कथाहरू" }) {
  const ref = useRef(null);
  const navigate = useNavigate();
  const enabled = Array.isArray(reels) ? reels : [];
  const visible = enabled.slice(0, MAX_REELS);
  const hasMore = enabled.length > MAX_REELS;

  const scroll = (dir) => {
    const el = ref.current;
    if (!el) return;
    const w = el.querySelector('.reel-card')?.offsetWidth || 220;
    el.scrollBy({ left: dir * (w + 14), behavior: 'smooth' });
  };

  if (visible.length === 0) return null;

  return (
    <section className="mb-14">
      {title && <SectionHeading title={title} />}
      <div className="relative">
        <button
          className="hidden md:flex absolute top-[40%] -translate-y-1/2 -left-4 w-10 h-10 rounded-full bg-white border border-line shadow-lg items-center justify-center z-[5] hover:bg-crimson hover:text-white hover:border-crimson"
          onClick={() => scroll(-1)}
          aria-label="Previous"
        >
          <ChevronLeft size={20} />
        </button>
        <div className="flex gap-3.5 overflow-x-auto no-scrollbar snap-x snap-mandatory pb-1" ref={ref}>
          {visible.map((r) => (
            <ReelCard key={r.id} reel={r} />
          ))}
          {hasMore && (
            <button
              onClick={() => navigate('/reels')}
              className="flex-[0_0_160px] md:flex-[0_0_190px] aspect-[9/16] rounded-2xl snap-start bg-paper-soft border border-dashed border-line text-muted flex flex-col items-center justify-center gap-2.5 cursor-pointer hover:border-crimson hover:text-crimson transition-colors"
            >
              <span className="font-display text-[15px] font-bold text-center px-3 leading-snug">
                थप रिल्स हेर्नुहोस्
              </span>
              <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-white border border-line shadow-sm">
                <ArrowRight size={16} />
              </span>
              <span className="text-[11.5px] font-semibold">+{enabled.length - MAX_REELS} अझै छन्</span>
            </button>
          )}
        </div>
        <button
          className="hidden md:flex absolute top-[40%] -translate-y-1/2 -right-4 w-10 h-10 rounded-full bg-white border border-line shadow-lg items-center justify-center z-[5] hover:bg-crimson hover:text-white hover:border-crimson"
          onClick={() => scroll(1)}
          aria-label="Next"
        >
          <ChevronRight size={20} />
        </button>
      </div>
    </section>
  );
}

export default ReelsSection;
